/// Paletas compartilhadas com o ZenPDV (PersonalizaForms / PdvForm).
export const THEME_PALETTES = [
  { value: 'Verde', primary: '#53CD9D', secondary: '#2FB591', ink: '#1F8A66' },
  { value: 'Vermelho', primary: '#CD6357', secondary: '#BE484A', ink: '#A33B35' },
  { value: 'Azul Turquesa', primary: '#53AFCD', secondary: '#2C97AB', ink: '#1E7A8C' },
  { value: 'Cinza', primary: '#778291', secondary: '#636E7D', ink: '#4A5563' },
  { value: 'Laranja', primary: '#D2691E', secondary: '#FFA07A', ink: '#A04F12' },
  { value: 'Lilás', primary: '#A457CD', secondary: '#9B28BE', ink: '#7A2FA0' },
  { value: 'Rosa', primary: '#CD57CC', secondary: '#BE298F', ink: '#9A2A98' },
  { value: 'Azul', primary: '#0495F0', secondary: '#0446F2', ink: '#0270BE' },
  { value: 'Amarelo', primary: '#CDBE57', secondary: '#BEA931', ink: '#8A7E1E' },
  { value: 'Borgonha', primary: '#800020', secondary: '#C04000', ink: '#5C0018' },
  { value: 'Esmeralda', primary: '#55CD6F', secondary: '#36BE4D', ink: '#2A9A45' },
  { value: 'Ametista', primary: '#9966CC', secondary: '#E0B0FF', ink: '#6E3FA0' },
  { value: 'Cobalto', primary: '#0047AB', secondary: '#3D59AB', ink: '#003580' },
  { value: 'Ocre', primary: '#CC7722', secondary: '#FFD700', ink: '#9A5A18' },
  { value: 'Berinjela', primary: '#8B769A', secondary: '#7E6087', ink: '#5F4E6B' },
];

export const DEFAULT_THEME_PALETTE = 'Azul';

export function resolvePalette(name) {
  const found = THEME_PALETTES.find((p) => p.value === name);
  return found || THEME_PALETTES.find((p) => p.value === DEFAULT_THEME_PALETTE);
}

export function hexToRgb(hex) {
  const h = hex.replace('#', '');
  const full = h.length === 3 ? h.split('').map((c) => c + c).join('') : h;
  const n = parseInt(full, 16);
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
}

export function rgba(hex, alpha) {
  const { r, g, b } = hexToRgb(hex);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
